export function getEnvMode() {
  return process.env.NODE_ENV === "production" ? "pro" : process.env.NODE_ENV;
}



// WEBPACK FOOTER //
// ./src/util/getEnvMode.js